export default function(keyPrice) {
    return {
        type: 'SET_KEYPRICE',
        keyPrice,
    }
}